import { HStack, VStack, Box } from "@gluestack-ui/themed";
import { LinearSliceChartProps } from "./types";

export const LinearSliceChart = ({ data }: LinearSliceChartProps) => {
  return (
    <VStack w="$full">
      <HStack height="$2" borderRadius={8} overflow="hidden">
        {data?.map((data, index) => {
          const backgroundColor = data.color;
          return (
            <Box
              key={`${data.value}-${index}`}
              backgroundColor={backgroundColor}
              width={`${data.value}%`}
            ></Box>
          );
        })}
      </HStack>
    </VStack>
  );
};
